import _slicedToArray from "/drone/src/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import { useCallback, useEffect, useState } from 'react';
import { eventBus } from '@deliveryhero/armor-system';
import { DateVectorRange } from '../../utils/DateVectorRange';
import { extractDataFromDOMEvent } from '../../utils/extractDataFromDOMEvent';
import { DATE_RANGE_PICKER_CLOSE_PANEL } from '../constants';
import { getLatestAvailableDate, isRangeLegit } from '../utils/range';
export var useDateRangePickerSelectionEvents = function useDateRangePickerSelectionEvents(_ref, _ref2) {
  var onChange = _ref.onChange,
    isDateSelectable = _ref.isDateSelectable,
    panelId = _ref.panelId,
    closeDropdown = _ref.closeDropdown,
    enableCloseOnSelect = _ref.enableCloseOnSelect;
  var enableOnChangeOnSingleClick = _ref2.enableOnChangeOnSingleClick;
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    selectionStartCandidate = _useState2[0],
    setSelectionStartCandidate = _useState2[1];
  var _useState3 = useState(null),
    _useState4 = _slicedToArray(_useState3, 2),
    selectionEndCandidate = _useState4[0],
    setSelectionEndCandidate = _useState4[1];
  var onReallyChange = useCallback(function (start, end) {
    var newSelection = [start, end];
    if (end.isSmallerThanOrEqual(start)) {
      newSelection = [end, start];
    }
    onChange(new DateVectorRange(newSelection[0], newSelection[1]));
    if (enableCloseOnSelect) {
      closeDropdown();
    }
  }, [closeDropdown, enableCloseOnSelect, onChange]);
  var onClosePanel = useCallback(function (_ref3) {
    var detail = _ref3.detail;
    var id = detail.id;
    if (id === panelId) {
      setSelectionStartCandidate(null);
      setSelectionEndCandidate(null);
    }
  }, [panelId]);
  useEffect(function () {
    eventBus.on(DATE_RANGE_PICKER_CLOSE_PANEL, onClosePanel);
    return function () {
      return eventBus.off(DATE_RANGE_PICKER_CLOSE_PANEL, onClosePanel);
    };
  }, [onClosePanel]);
  var onClick = useCallback(function (event) {
    var data = extractDataFromDOMEvent(event);
    if (!data) {
      return;
    }
    var vector = data.vector,
      displayedMonth = data.displayedMonth;
    var allowed = isDateSelectable(vector);
    if (!displayedMonth || !allowed) {
      return;
    }
    if (enableOnChangeOnSingleClick) {
      onReallyChange(vector.clone(), vector.clone());
      setSelectionStartCandidate(null);
      setSelectionEndCandidate(null);
    } else {
      if (selectionStartCandidate) {
        // the beginning was already chosen
        var endDate = vector.clone();
        if (isRangeLegit(selectionStartCandidate, endDate, isDateSelectable)) {
          onReallyChange(selectionStartCandidate, endDate);
          setSelectionStartCandidate(null);
          setSelectionEndCandidate(null);
        }
      } else {
        // set the beginning
        setSelectionStartCandidate(vector.clone());
      }
    }
  }, [isDateSelectable, selectionStartCandidate, onReallyChange, enableOnChangeOnSingleClick]);
  // when the mouse is moving over a calendar item, we set it as a selection end candidate
  var onMouseEnter = useCallback(function (event) {
    var data = extractDataFromDOMEvent(event);
    if (!data) {
      return;
    }
    var vector = data.vector,
      displayedMonth = data.displayedMonth;
    if (!displayedMonth) {
      return;
    }
    if (selectionStartCandidate) {
      setSelectionEndCandidate(getLatestAvailableDate(selectionStartCandidate, vector.clone(), isDateSelectable));
    }
  }, [isDateSelectable, selectionStartCandidate]);
  return {
    dayButtonProps: {
      onClick: onClick,
      onMouseEnter: onMouseEnter
    },
    selectionStartCandidate: selectionStartCandidate,
    selectionEndCandidate: selectionEndCandidate
  };
};